module.exports = __webpack_public_path__ + "img/case1.42b66a24.jpg";